import { render, staticRenderFns } from "./merchantAll.vue?vue&type=template&id=0bec2302&scoped=true&"
import script from "./merchantAll.vue?vue&type=script&lang=js&"
export * from "./merchantAll.vue?vue&type=script&lang=js&"
import style0 from "./merchantAll.vue?vue&type=style&index=0&id=0bec2302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bec2302",
  null
  
)

export default component.exports